/* Compteurs animés de la page à propos */
(function () {
  "use strict";
  var box = document.getElementById("aboutStats");
  if (!box) return;
  var played = false;

  function play() {
    if (played) return;
    played = true;
    var els = Array.prototype.slice.call(box.querySelectorAll("b[data-count]"));
    els.forEach(function (el) {
      var target = parseInt(el.getAttribute("data-count"), 10) || 0;
      var suffix = el.getAttribute("data-suffix") || "";
      if (window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches) {
        el.textContent = target + suffix;
        return;
      }
      var start = null, dur = 1200;
      function step(now) {
        if (start === null) start = now;
        var p = Math.min(1, (now - start) / dur);
        el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }

  if ("IntersectionObserver" in window) {
    var obs = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { play(); obs.disconnect(); }
    }, { threshold: 0.25 });
    obs.observe(box);
    /* filet de sécurité si l'observateur ne se déclenche pas */
    setTimeout(play, 1500);
  } else {
    play();
  }
})();
